import styled, { css } from 'styled-components';
import { MEDIA_QUERY } from '@optimus-web/breakpoints';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { SlideAnimator } from '../SlideAnimator';

const ArrowContainer = styled.div`
    height: ${getToken('sizing600')}px;
    width: ${getToken('sizing500')}px;
    box-sizing: border-box;

    position: absolute;
    z-index: 9;

    ${MEDIA_QUERY.tabletMax} {
        width: ${getToken('sizing300')}px;
    }
`;

export const ArrowLeftContainer = styled(ArrowContainer)`
    background: linear-gradient(270deg, transparent 0%, ${getToken('backgroundStaticFlat')} 50%);
    justify-content: flex-start;
    left: 0;

    ${MEDIA_QUERY.desktopUp} {
        padding-left: ${getSpacingToken('100')}px;
        background: linear-gradient(270deg, transparent 0%, ${getToken('backgroundStaticFlat')} 25%);
    }
`;

export const ArrowRightContainer = styled(ArrowContainer)`
    background: linear-gradient(90deg, transparent 0%, ${getToken('backgroundStaticFlat')} 50%);
    justify-content: flex-end;
    right: 0;

    ${MEDIA_QUERY.desktopUp} {
        padding-right: ${getSpacingToken('100')}px;
        background: linear-gradient(90deg, transparent 0%, ${getToken('backgroundStaticFlat')} 25%);
    }
`;

export const SlideAnimatorElement = styled(SlideAnimator)<{ showDivider?: boolean }>`
    ${({ showDivider }) =>
        showDivider &&
        css`
            box-shadow: inset 0 -${getToken('borderWidth150')}px 0 0 ${getToken('borderDisabled')};
        `}
`;
